export default __webpack_public_path__ + "static/media/brand2.09d8302a.webp";